import Flag from "@components/Flag";
import type { Market } from "@features/market/config/i18n-config";
import { languageName } from "@features/market/config/market-config";
import type { ComponentPropsWithoutRef, ElementType } from "react";

import { cn } from "@/lib/utils";

type MarketSelectorOptionProps<T extends ElementType> = {
  as?: T;
  market: Market;
};

export default function MarketSelectorOption<T extends ElementType>(
  props: MarketSelectorOptionProps<T> &
    Omit<ComponentPropsWithoutRef<T>, keyof MarketSelectorOptionProps<T>>,
) {
  const { as, market, className, ...rest } = props;
  const Component = as || "li";

  return (
    <Component
      className={cn(
        "flex cursor-pointer items-center space-x-2 p-3",
        className,
      )}
      key={market.countryCode}
      {...rest}
    >
      <Flag
        code={market.countryCode}
        className="h-4 w-4 shrink-0 rounded-full border border-black object-cover"
      />
      <span className="flex-1">
        <b>{market.countryName}</b>&nbsp;({languageName(market.languageCode)})
      </span>
      <span className="shrink-0 text-gray-400 uppercase">
        {market.currency}
      </span>
    </Component>
  );
}
